// extracted by mini-css-extract-plugin
export default {"Main":"Static_Main__hG8RC","Wrapper":"Static_Wrapper__aIJwi","li":"Static_li__67p5R","h6":"Static_h6__chUkW","padding":"Static_padding__RvZVX"};